import { render, staticRenderFns } from "./DCConfirmDelivery.vue?vue&type=template&id=679db1aa&scoped=true&"
import script from "./DCConfirmDelivery.vue?vue&type=script&lang=js&"
export * from "./DCConfirmDelivery.vue?vue&type=script&lang=js&"
import style0 from "./DCConfirmDelivery.vue?vue&type=style&index=0&id=679db1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679db1aa",
  null
  
)

export default component.exports